import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CancelAppointmentModal = ({ open, appointment, onClose, onSubmit, saving }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  if (!open || !appointment) return null;

  const title = appointment.serviceName || t('appointments.cancel.fallbackService');
  const place = appointment.salonName || appointment.branchName || t('appointments.cancel.fallbackPlace');

  return (
    <>
      <div className="fixed inset-0 z-40 bg-black/50" onClick={onClose} />
      <div className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 p-6">
        <h2 className="text-lg font-semibold">{t('appointments.cancel.title')}</h2>
        <p className="mt-1 text-sm text-zinc-600 dark:text-zinc-500">
          {t('appointments.cancel.subtitle', { service: title, place })}
        </p>
        <p className="mt-3 text-sm text-zinc-600 dark:text-zinc-400">
          {t('appointments.cancel.reasonHint')}
        </p>
        <label className="mt-4 block text-sm text-zinc-600 dark:text-zinc-400" htmlFor="cancel-reason">
          {t('appointments.cancel.reasonLabel')}
        </label>
        <textarea
          id="cancel-reason"
          value={reason}
          onChange={(e) => setReason(e.target.value.slice(0, 500))}
          rows={4}
          placeholder={t('appointments.cancel.reasonPlaceholder')}
          className="mt-1 w-full rounded-lg border border-zinc-300 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-950 px-3 py-2 text-sm"
        />
        <p className="mt-1 text-right text-xs text-zinc-600 dark:text-zinc-500">{reason.trim().length}/500</p>
        <div className="mt-4 flex gap-3">
          <button type="button" onClick={onClose} className="flex-1 rounded-lg border border-zinc-300 dark:border-zinc-700 py-2 text-sm">
            {t('appointments.cancel.keepAppointment')}
          </button>
          <button
            type="button"
            disabled={saving || !reason.trim()}
            onClick={() => onSubmit(reason.trim())}
            className="flex-1 rounded-lg border border-red-800 bg-red-950/40 py-2 text-sm text-red-300 disabled:opacity-50"
          >
            {saving ? t('appointments.cancel.cancelling') : t('appointments.cancel.confirmCancellation')}
          </button>
        </div>
      </div>
    </>
  );
};

export default CancelAppointmentModal;
